import request from '@/assets/js/myAxios'

export async function login(data) {
  
  return request({
    url: '/api/mall_member/UserLogin',
    method: 'post',
    data,
  })
}

export  function addUser(data) {
  return request({
    url: '/api/mall_member/CreatedUser',
    method: 'post',
    data,
  })
}
//获取信息
export  function getUserInfo(data) {
  return request({
    url: '/api/mall_member/GetUserInfo?token='+data,
    method: 'get',
  })
}
//修改信息
export  function updateUserInfo(data) {
  return request({
    url: '/api/mall_member/UpdateUserInfo',
    method: 'post',
    data
  })
}

//修改密码
export  function updateUserPwd(data) {
  return request({
    url: '/api/mall_member/UpdateUserPwd'+data,
    method: 'get',
  })
}


export async function Update(data) {
  return request({
    url: '/api/mall_member/Update',
    method: 'post',
    data,
  })
}

export async function addContactMsg(data) {
  return request({
    url: '/api/mall_Contact/Add',
    method: 'post',
    data,
  })
}

//个人中心留言
export async function addLeaveMsg(id,data) {
  return request({
    url: '/api/mall_leavemsg/userSendMsg?id='+id,
    method: 'post',
    data,
  })
}


//发送验证码
export async function SendCode(id) {
  return request({
    url: '/api/mall_member/SendCode?emailAds='+id,
    method: 'get',
  })
}


//发校验验证码
export async function VerificationCode(id) {
  return request({
    url: '/api/mall_member/VerificationCode'+id,
    method: 'get',
  })
}

//通过验证码找回密码
export async function ResetPassword(id) {
  return request({
    url: '/api/mall_member/ResetPassword'+id,
    method: 'get',
  })
}




